import { useState, ReactNode } from 'react'

import { Loadable } from '@scouts/ui'

import { getIsCompanyTier } from '@/domain/company'
import { SubscriptionTiers, UserAgreementType } from '@/models'
import { usePendingAgreement } from '@/store/agreements'
import { useProfile } from '@/store/profile'

import { SignPendingAgreementModal } from './SignPendingAgreementModal'

interface PendingAgreementProps {
    children: ReactNode
}

export const PendingAgreement = ({ children }: PendingAgreementProps) => {
    const { latestSubscription } = useProfile()
    const { subscriptionTierType } = latestSubscription || {}

    const { data: personalAgreement, isInitializing: isInitializingPersonalAgreement } = usePendingAgreement({
        skipFetch: !latestSubscription,
        agreementType: UserAgreementType.Personal,
    })
    const { data: companyAgreement, isInitializing: isInitializingCompanyAgreement } = usePendingAgreement({
        skipFetch: !latestSubscription || !getIsCompanyTier(subscriptionTierType as SubscriptionTiers),
        agreementType: UserAgreementType.Company,
    })
    const [isPersonalAgreementSigned, setIsPersonalAgreementSigned] = useState(false)
    const [isCompanyAgreementSigned, setIsCompanyAgreementSigned] = useState(false)

    const handlePersonalAgreementClick = () => {
        setIsPersonalAgreementSigned(true)
    }
    const handleCompanyAgreementClick = () => {
        setIsCompanyAgreementSigned(true)
    }

    if (isInitializingPersonalAgreement || isInitializingCompanyAgreement) return <Loadable isLoading />

    if (personalAgreement && !isPersonalAgreementSigned && subscriptionTierType)
        return (
            <SignPendingAgreementModal agreement={personalAgreement} onAgreementSign={handlePersonalAgreementClick} />
        )
    if (companyAgreement && !isCompanyAgreementSigned && subscriptionTierType)
        return <SignPendingAgreementModal agreement={companyAgreement} onAgreementSign={handleCompanyAgreementClick} />

    return <>{children}</>
}
